import React from "react";
import AIcon from "../partials/AIcon";
import ReactPaginate from 'react-paginate';

export default function Pagination({ value }) {



  //console.log(value)
  const handlePagination = ({ selected: selectedPage }) => {
    console.log(selectedPage);
    action(selectedPage + 1)

  };

  const action = (num) => {
    value.getFun(num)
  }


  return (
    <div className="flex flex-row justify-center md:justify-between p-4 w-full">
      <ReactPaginate
        previousLabel={<AIcon name="arrow-back-outline" ClassName="mt-5" />}
        nextLabel={<AIcon name="arrow-forward-outline" ClassName="mt-5" />}
        pageCount={value?.data?.last_page}
        onPageChange={handlePagination}
        pageRangeDisplayed={3}
        marginPagesDisplayed={2}
        renderOnZeroPageCount={null}
        containerClassName={"pagination"}
        previousLinkClassName={"pagination__link"}
        nextLinkClassName={"pagination__link"}
        disabledClassName={"pagination__link--disabled"}
        activeClassName={"pagination__link--active"}
      />

      <p className="hidden md:block text-main-color">Total: <span>{value.data.total} items</span></p>
    </div>
  );
}